export default {
    "Routes.name.home": "home my guys",
    "Routes.name.example": "example",
    "Routes.name.admin": "admin",
}